document.addEventListener('DOMContentLoaded', function () {
  const tax_percent = document.getElementById('tax-percent').dataset.tax;
  const quickOrderSpinner = document.querySelector('.quick-order__basket .loading__spinner');
  const quickOrderTableBody = document.querySelector('table.quick-order-items tbody');
  const defaultRow = document.querySelector('table.quick-order-items tbody > tr:first-of-type').cloneNode(true);
  let currentRow = document.querySelector('tr');
  let rowPrice = currentRow.querySelector('.quick-order__price.price-incl');
  const formData = {
    items: [],
    sections: ['cart-drawer', 'cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'],
  };

  addRowListeners();

  function addRowListeners() {
    document.querySelectorAll('.quick-order-items tbody tr').forEach((itemRow, index) => {
      itemRow.querySelector('.quick-order__count h5').innerText = index + 1;
    });
    document.querySelectorAll('.quick-order__retrieve').forEach((retrieveButton) => {
      retrieveButton.addEventListener('click', (event) => {
        updateQuickOrderRow(event.target);
        currentRow.querySelector('.quick-order__item-name').innerText = '';
        fetch(
          `/search/suggest.json?q=${currentRow.querySelector('.quick-order__id').value}&resources[type]=product&resources[options][fields]=variants.sku&resources[options][unavailable_products]=show`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
          .then((response) => response.json())
          .then((response) => {
            const products = response.resources?.results.products;
            if (products.length === 0) {
              currentRow.querySelector('.quick-order__item-name').innerText =
                'Product not found. Please check the SKU.';
              return;
            }
            const product = products[0];
            const productId = product.id;
            const productTags = product.tags;
            fetch(`/products/${product.handle}.json`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
            })
              .then((response) => response.json())
              .then((response) => {
                const matchingVariant = response.product.variants.find(
                  (variant) =>
                    variant.sku.toLowerCase() === currentRow.querySelector('.quick-order__id').value.toLowerCase(),
                );
                if (!matchingVariant) {
                  currentRow.querySelector('.quick-order__item-name').innerText =
                    'Product not found. Please Enter the EXACT SKU.';
                  return;
                }
                currentRow.setAttribute('data-product_id', productId);
                currentRow.setAttribute('data-variant_id', matchingVariant.id);

                if (productTags.includes('Personalised')) {
                  currentRow.querySelector('.quick-order__item-name').innerText =
                    'Cannot add to basket, visit the product page to personalise';
                } else {
                  currentRow.querySelector('.quick-order__item-name').innerText = product.title;
                  updateRowPrice(Number(matchingVariant?.price ?? product.price) * 100, true);
                  updateTotalPrice();
                  addFormData(productId, 1, matchingVariant.id);
                  if (!currentRow.closest('tr').nextElementSibling) {
                    quickOrderTableBody.append(defaultRow.cloneNode(true));
                  }
                  addRowListeners();
                }
              });
          });
      }, { once: true });
    });

    document.querySelectorAll('.quantity__input').forEach((qtyInput) => {
      qtyInput.addEventListener('change', (event) => {
        updateQuickOrderRow(event.target);
        const itemQty = Number(event.target.value);
        if (itemQty < 1 && quickOrderTableBody.children.length === 1) {
          location.reload();
        } else if (itemQty < 1) {
          deleteFormData(currentRow.dataset.product_id);
          quickOrderTableBody.removeChild(currentRow);
          addRowListeners();
        } else {
          const price = rowPrice.dataset.price * itemQty;
          updateRowPrice(price, false);
          addFormData(Number(currentRow.dataset.product_id), itemQty, Number(currentRow.dataset.variant_id));
        }
        updateTotalPrice();
      });
    });
  }

  document.querySelector('.quick-order__add-row').addEventListener('click', () => {
    quickOrderTableBody.append(defaultRow.cloneNode(true));
    addRowListeners();
  });

  document.querySelectorAll('.quick-order__basket').forEach((quickBasketButton) => {
    quickBasketButton.addEventListener('click', (event) => {
      event.target.classList.add('loading');
      const spinner = event.target.querySelector('.loading__spinner');
      spinner.classList.remove('hidden');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            cartData: response,
          });
          (document.querySelector('cart-notification') || document.querySelector('cart-drawer')).renderContents(
            response,
          );
          formData.items = [];
          refreshRows();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          event.target.classList.remove('loading');
          spinner.classList.add('hidden');
        });
    });
  });

  function addFormData(productId, productQty, variantId) {
    const itemIndex = formData.items.findIndex((item) => item['product-id'] === productId);
    if (itemIndex === -1) {
      formData.items.push({
        'product-id': productId,
        quantity: productQty,
        id: variantId,
      });
    } else {
      formData.items[itemIndex]['quantity'] = productQty;
    }
  }

  function deleteFormData(productId) {
    formData.items.splice(
      formData.items.findIndex((item) => item['product-id'] === productId),
      1,
    );
  }

  function updateQuickOrderRow(element) {
    currentRow = element.closest('tr');
    rowPrice = currentRow.querySelector('.quick-order__price.price-incl');
  }

  function updateRowPrice(price, newPrice) {
    if (newPrice) {
      rowPrice.setAttribute('data-price', price);
    }
    rowPrice.setAttribute('data-total_price', price);
    rowPrice.innerText = Shopify.formatMoney(price);
    currentRow.querySelector('.quick-order__price.price-excl').innerText = Shopify.formatMoney(price / tax_percent);
  }

  function updateTotalPrice() {
    let totalPrice = 0;
    document.querySelectorAll('.quick-order__price.price-incl').forEach((subTotal) => {
      if (!isNaN(parseFloat(subTotal.dataset.total_price))) {
        totalPrice += Number(subTotal.dataset.total_price);
      }
    });
    document.querySelector('.quick-order__total.price-incl').innerText = Shopify.formatMoney(totalPrice);
    document.querySelector('.quick-order__total.price-excl').innerText = Shopify.formatMoney(totalPrice / tax_percent);
  }

  function refreshRows() {
    quickOrderTableBody.innerHTML = '';
    quickOrderTableBody.append(defaultRow.cloneNode(true));
    addRowListeners();
  }
});
